import { render } from "./ImageAndText.vue?vue&type=template&id=2742db4c&scoped=true"
import script from "./ImageAndText.vue?vue&type=script&lang=js"
export * from "./ImageAndText.vue?vue&type=script&lang=js"

import "./ImageAndText.vue?vue&type=style&index=0&id=2742db4c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src85092301/src/landing-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2742db4c"]])

export default __exports__